define("shared/modifiers/touch-gesture", ["exports", "@ember/destroyable", "ember-modifier"], function (_exports, _destroyable, _emberModifier) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/destroyable",0,"ember-modifier"eaimeta@70e063a35619d71f
  /**
   * TouchGestureModifier is used to add listeners for touchstart, touchmove and touchend
   * events on the element.
   */
  function cleanup(instance) {
    instance.element?.removeEventListener('touchstart', instance.onTouchStartHandler);
    instance.element?.removeEventListener('touchmove', instance.onTouchMoveHandler);
    instance.element?.removeEventListener('touchend', instance.onTouchEndHandler);
  }
  class TouchGestureModifier extends _emberModifier.default {
    constructor(owner, args) {
      super(owner, args);
      (0, _destroyable.registerDestructor)(this, cleanup);
    }
    modify(element, _positionalArgs, _ref) {
      let {
        onTouchStart,
        onTouchMove,
        onTouchEnd
      } = _ref;
      this.onTouchStartHandler = this.createOnTouchHandler(onTouchStart);
      this.onTouchMoveHandler = this.createOnTouchHandler(onTouchMove);
      this.onTouchEndHandler = this.createOnTouchHandler(onTouchEnd);
      element.addEventListener('touchstart', this.onTouchStartHandler);
      element.addEventListener('touchmove', this.onTouchMoveHandler);
      element.addEventListener('touchend', this.onTouchEndHandler);
    }
    createOnTouchHandler(onTouchStart) {
      return event => {
        onTouchStart?.(event);
      };
    }
  }
  _exports.default = TouchGestureModifier;
});